var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import IncomeCaptureStateProvider, { INCOME_CAPTURE_VIEWS, } from "../context/incomeCaptureContext";
import IncomeCaptureModal from "../ui/templates/IncomeCaptureModal";
import IncomeCaptureDefaultProviders from "../context/IncomeCaptureDefaultProviders";
var IncomeCaptureRoot = function (_a) {
    var config = _a.config, selectedAccountId = _a.selectedAccountId, isModalOpen = _a.isModalOpen, containerId = _a.containerId, handleClose = _a.handleClose;
    var initialState = useMemo(function () { return ({
        accountId: selectedAccountId,
        isModalOpen: isModalOpen,
        isMutationLoading: false,
        view: INCOME_CAPTURE_VIEWS.UPDATE_INCOME,
    }); }, [isModalOpen, selectedAccountId]);
    return (_jsx(IncomeCaptureDefaultProviders, __assign({ config: config }, { children: _jsx(IncomeCaptureStateProvider, __assign({ handleClose: handleClose, initialState: initialState }, { children: _jsx(IncomeCaptureModal, { containerId: containerId }) })) })));
};
export default IncomeCaptureRoot;
